module.exports = __webpack_public_path__ + "static/media/20150616_764458_322533.03409ad7.mp3";